import { render } from "./V2Style.vue?vue&type=template&id=1c1e371a&scoped=true"
import script from "./V2Style.vue?vue&type=script&lang=js"
export * from "./V2Style.vue?vue&type=script&lang=js"

import "./V2Style.vue?vue&type=style&index=0&id=1c1e371a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1e371a"]])

export default __exports__